import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/startOfQuarter/index.js';

var require$$43 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$43 as default };
